const programmeBreadcrumb = { name: "Programmes", route: "project-list" };

export default [
  {
    path: "/programmes/:id/setup/",
    name: "programme-setup",
    component: () => import("@/features/programme-setup/pages/ProgrammeSetupPage.vue"),
    props: (route) => ({
      id: Number(route.params.id),
      projectId: Number(route.params.id),
      programmeId: Number(route.params.id),
    }),
    meta: {
      requiresAuth: true,
      requiresProjectAdmin: true,
      layout: "app",
      group: "Programmes",
      title: "Programme Setup",
      breadcrumbs: [
        programmeBreadcrumb,
        { name: "Scenario Select", route: "project-workspace" },
        { name: "Programme Setup", route: "programme-setup" },
      ],
    },
  },

  {
    path: "/programmes/:id/settings/",
    name: "programme-settings-legacy",
    redirect: (to) => ({
      name: "programme-setup",
      params: { id: to.params.id },
      query: to.query,
      hash: to.hash,
    }),
  },

  {
    path: "/projects/:id/setup/",
    name: "project-setup-legacy",
    redirect: (to) => ({
      name: "programme-setup",
      params: { id: to.params.id },
      query: to.query,
      hash: to.hash,
    }),
  },
];
